'use strict';

module.exports.MIMES_extensions = {
  'image/svg+xml': '.svg',
  'image/png': '.png',
  'image/apng': '.png',
  'image/jpeg': '.jpg, .jpeg',
  'image/gif': '.gif',
  'audio/wave': '.wav',
  'audio/wav': '.wav',
  'audio/x-wav': '.wav',
  'audio/x-pn-wav': '.wav',
  'audio/ogg': '.ogg',
  'video/ogg': '.ogg',
  'application/ogg': '.ogg',
  'text/plain': '.txt',
  'text/csv': '.csv',
  'application/pdf': '.pdf',
  'application/zip': '.zip',
  'application/x-zip-compressed': '.zip',
  'application/xml': '.xml',
  'application/dicom': '.dcm'
};
